<div *ngIf="(carrier | json) != '{}'">
    <div class="row">
        <div class="col-sm-6">
            <div class="row">
                <div class="col-sm-12">
                    <h3>Carrier</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3">
                    <label class="font-weight-bold">Name</label>
                </div>
                <div class="col-sm-9">
                    <input type="text" class="form-control" [(ngModel)]="carrier.name" required />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3">
                    <label class="font-weight-bold">MC #</label>
                </div>
                <div class="col-sm-9">
                    <input type="text" class="form-control" [(ngModel)]="carrier.mcNumber" required />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3">
                    <label class="font-weight-bold">DOT #</label>
                </div>
                <div class="col-sm-9">
                    <input type="text" class="form-control" [(ngModel)]="carrier.dotNumber" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3">
                    <label class="font-weight-bold">SCAC</label>
                </div>
                <div class="col-sm-9">
                    <input type="text" class="form-control" [(ngModel)]="carrier.scacCode" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3">
                    <label class="font-weight-bold">Address 1</label>
                </div>
                <div class="col-sm-9">
                    <input type="text" class="form-control" [(ngModel)]="carrier.address1" required />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3">
                    <label class="font-weight-bold">Address 2</label>
                </div>
                <div class="col-sm-9">
                    <input type="text" class="form-control" [(ngModel)]="carrier.address2" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3">
                    <label class="font-weight-bold">City</label>
                </div>
                <div class="col-sm-9">
                    <!--<city-dropdown [parentForm]="carrierForm" [ctrlName]="'cityControl'" [placeholder]="'Select a City'" [isRequired]="true"></city-dropdown>-->
                    <city-state-zip-dropdown [parentForm]="carrierForm" [ctrlName]="'cityStateZipCtrl'" [placeholder]="'Select a City'"
                                             (citySelected)="citySTChanged($event)" [cityID]="carrier.cityID" [isRequired]="true"></city-state-zip-dropdown>
                </div>
            </div>
            <div class="row" *ngIf="false">
                <div class="col-sm-3">
                    <label class="font-weight-bold">Zip</label>
                </div>
                <div class="col-sm-9">
                    <input type="text" class="form-control" [(ngModel)]="userEnteredZip" required />
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <button class="btn btn-primary m-2" (click)="saveCarrier()" *ngIf="!carrier.carrierID">Save</button>
                    <button class="btn btn-secondary m-2" (click)="cancelCarrier()" *ngIf="!carrier.carrierID">Cancel</button>
                </div>
            </div>
        </div>
        <div class="col" *ngIf="contactID>0">
            <div class="row">
                <div class="col-sm-12">
                    <h3>Contact</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <!--<contact-quick-add [tableID]="carrier.carrierID" [contactTitleID]="2" [contactType]="'Carrier'" [countryCode]="countryCode" (onRefreshContact)="refreshCarrier()"></contact-quick-add>-->
                    <contact-quick-edit [contactID]="contactID" (onRefreshContact)="refreshCarrier()"></contact-quick-edit>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay': isLoading}">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>
